import { render, staticRenderFns } from "./StorageShippingUnitsConsultationList.vue?vue&type=template&id=4ab3e002&scoped=true&"
import script from "./StorageShippingUnitsConsultationList.vue?vue&type=script&lang=ts&"
export * from "./StorageShippingUnitsConsultationList.vue?vue&type=script&lang=ts&"
import style0 from "./StorageShippingUnitsConsultationList.vue?vue&type=style&index=0&id=4ab3e002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3e002",
  null
  
)

export default component.exports